export default [
  {
    name: 'restRoomQuery',
    method: 'post',
    desc: '机场服务-休息室-询价列表',
    path: '/obt/airport/shopping/apRepLounge/queryList',
    params: {
      'productType': 0,//产品类型 1 机场 2火车站
      'airTrainCode': '',//机场三字码或火车站点
      'terminal': '',//航站楼
      'leaveType': 0,//出发类型 1 国内出发 2 国际出发
      'securityCheck': 0,//安检内外 1 安检内 2 安检外
      'pageNum': 0,
      'count': 0,
      sortType: 1
    }
  },
  {
    name: 'restRoomDetail',
    method: 'post',
    desc: '机场服务 - 休息室 - 详情',
    path: '/obt/airport/shopping/apRepLounge/detail',
    params: {
      id: ''
    }
  },
  {
    name: 'checkInQuery',
    method: 'post',
    desc: '机场服务-优先值机询价',
    path: '/obt/airport/shopping/check/enquiry',
    params: {
      'flightNumber': '',
      'targetDate': ''
    }
  },
  {
    name: 'fastCheckQuery',
    method: 'post',
    desc: '快速安检询价',
    path: '/obt/airport/shopping/security/querySecuList',
    params: {
      'productType': 1,//产品类型 1 机场 2火车站 ,
      'airTrainCode': '',//机场三字码或火车站点 ,
      'terminal': '',//航站楼
      'leaveType': 1,//出发类型
    }
  },
  {
    name: 'guestPassQuery',
    method: 'post',
    desc: '通过航班号查询报价',
    path: '/obt/airport/shopping/guests/queryByFlightNo',
    params: {
      'threeCode': '',
      'serviceType': 1,//1接机 2送机
      'flightType': 1,//1国内 2国际
    }
  },
  {
    name: 'queryFacilities',
    method: 'post',
    desc: '基础服务设施查询',
    path: '/obt/airport/set/facilities/queryFacilities',
    params: {
      type: '',
    }
  },
  {
    name: 'bookOrder',
    method: 'post',
    desc: '机场服务-订单-下单',
    path: '/obt/airport/order/bookOrder',
    params: {
      'orderType': '',
      'productId': '',
      'personTime': '',
      'flightDate': '',
      'flightNo': '',
      'deptCity': '',
      'deptCityName': '',
      'arrCity': '',
      'arrCityName': '',
      'seatType': '',
      'psgBeanList': [
        {
          'psgName': '',
          'psgType': '',
          'cardType': '',
          'idNo': '',
          'phoneNumber': '',
          'empId': '',
        }
      ],
      'serverTime': '',
      'serverType': '',
      'serverAirportCode': '',
      'serverAirportName': '',
      'linkman': '',
      'linkMobile': '',
      'tripType': '',
      'linkEmail': '',
      'travelInfo': {
        'projectId': '',
        'projectCode': '',
        'projectName': '',
        'ccsqdId': '',
        'ccsqdNo': '',
        'routeId': '',
        'costCenterId': '',
        'costCenterCode': '',
        'costCenterName': '',
        'violateitemCode': '',
        'violateitem': '',
        'reasonCode': '',
        'reasonDesc': '',
        'corpId': '',
        'corpCode': '',
        'corpName': '',
        'tripType': '',
        'ccsqdRemark': '',
        'subjectCode': '',
        'ifSameOrder': '',
        'logotype': ''
      },
      'orderFrom': '',
      'sendMethod': '',
      'recipient': '',
      'reciPhone': '',
      'reciEmail': '',
      'reciPostCode': '',
      'reciAddr': '',
      'postCode': '',
      'psyqsj': '',
      'postMothed': '',
      'fyid': '',
      'recommender': '',
      'recommenderName': '',
      'corpBookerId': '',
      'relateOrder': '',
      'serverRemark': '',
      'setOutModel': '',
      'flightTime': '',
      'flightToDate': '',
      'flightToTime': '',
      'airlineName': '',
      'airlineImg': '',
      'terminal': '',
      'toTerminal': '',
      'toAirportCode': '',
      'toAirportName': '',
      'acceptSeat': '1', // 座位偏好接受调整
      'salePrice': '', // 销售价
      'costPrice': '', // 成本价
      'jj': '', // 加价
      'seatNo': '', // 座位编码
    }
  },
  {
    name: 'orderDetail',
    method: 'post',
    desc: '机场服务-订单-订单详',
    path: '/obt/airport/order/orderDetail',
    params: {
      orderId: '',
    }
  },
  {
    name: 'cancel',
    method: 'post',
    desc: '机场服务-订单-取消订单',
    path: '/obt/airport/order/cancel',
    params: {
      orderId: '',
      version: '',
      orderFrom: '',
    }
  },
  {
    name: 'airTicketOrderDetail',
    method: 'get',
    desc: '机票订单',
    path: '/obt/orderDetail',
    params: {
      'id': ''
    }
  },
]
